import { WidgetType } from '../../../Widget';
import type { IInputWidget } from '../IInputWidget';

export enum TextWidgetKind {
  Text = 'text',
  TextArea = 'textarea',
}

/**
 * Input Testo
 */
export interface ITextWidget extends IInputWidget {
  type: WidgetType.Text;
  kind: TextWidgetKind;
  placeholder?: string;
}
